import { render, staticRenderFns } from "./PaymentCustomer.vue?vue&type=template&id=33ea833a&scoped=true&"
import script from "./PaymentCustomer.vue?vue&type=script&lang=js&"
export * from "./PaymentCustomer.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCustomer.vue?vue&type=style&index=0&id=33ea833a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ea833a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VDataTable,VDivider,VIcon,VLayout,VSpacer})
